import { mode_edit, mode_view } from '../../../../../../views/my-store/google-profile';

export default {
  title: 'Profil Google',
  sections: {
    current_profile: {
      [mode_view]: 'Profil conectat',
      [mode_edit]: 'Schimbă profilul conectat',
    },
  },
  form: {
    google_places_id: {
      label: 'Nume Google Maps',
    },
    address: {
      label: 'Adresă',
    },
    rating: {
      label: 'Evaluare',
    },
    opening_hours: {
      label: 'Program de lucru',
    },
    phone_number: {
      label: 'Număr de telefon',
    },
    pictures: {
      label: 'Imagini',
    },
  },
  labels: {
    no_place_connected: 'Acest restaurant nu are niciun profil Google conectat',
    fields_to_sync: 'Informații de sincronizat din {{name}}',
  },
  buttons: {
    save: 'Salvează',
    change: 'Schimbă',
    cancel: 'Anulează',
  },
  toasts: {
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
